import cn from 'classnames';
import { FC } from 'react';

import emptyImage from '../../../../assets/images/emptyImage.svg';
import { ICatalogItem } from '../../../../shared/types/card';

import styles from './CardGallery.module.sass';

interface ICardGallery {
  item: ICatalogItem;
  activeImage: number;
  setActiveImage: (num: number) => void;
}

const CardGallery: FC<ICardGallery> = ({
  item,
  activeImage,
  setActiveImage,
}) => {
  return (
    <div className={styles.gallery}>
      <ul>
        {item?.img_thumb.map((image, index) => (
          <li
            onClick={() => setActiveImage(index)}
            key={index}
            className={cn(styles.image, styles.small, {
              [styles.active]: activeImage === index,
            })}
          >
            <img src={image || emptyImage} alt="index" />
          </li>
        ))}
      </ul>
      <div className={cn(styles.image, styles.big)}>
        <img
          src={item?.img_thumb[activeImage] || emptyImage}
          alt={item?.title}
        />
      </div>
    </div>
  );
};

export default CardGallery;
